import join_img_1 from '../assets/join_image/join_img_1.png';
import join_img_2 from '../assets/join_image/join_img_2.png';
import join_img_3 from '../assets/join_image/join_img_3.png';
import join_img_4 from '../assets/join_image/join_img_4.png';

const joinCards = [
  {
    image: join_img_1,
    title: 'Recent College Graduate',
    description:
      'Start your financial journey strong with real-world trading skills that lay the foundation for long-term independence.',
  },
  {
    image: join_img_2,
    title: 'Working Professional',
    description:
      "Whether you're in tech, the trades, or freelancing—this program is built for busy professionals, digital nomads, and blue-collar workers ready to grow their income potential.",
  },
  {
    image: join_img_3,
    title: 'Stay-at-Home Parent',
    description:
      "Balance family life and finances. Learn to trade from home and build lasting skills that support your household's future.",
  },
  {
    image: join_img_4,
    title: 'Retiree or Near-Retirement',
    description:
      'Turn your experience and savings into smarter income. This program helps you trade with confidence, no matter your age.',
  },
];

const WhoCanJoin = ({ variant = 'classic' } = {}) => {
  if (variant === 'v2') {
    return (
      <section className="relative overflow-hidden bg-[#f8f7fc] py-20 sm:py-28">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(103,86,254,0.07),transparent_55%)]" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-bold tracking-[0.3em] text-[#6756FE] uppercase">
              Who can join
            </p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Built for every stage of life
            </h2>
            <p className="mt-4 text-slate-500">
              Option trading is no longer exclusive. Anyone can learn and succeed — regardless of background or experience.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 sm:gap-5">
            {joinCards.map((item) => (
              <article
                key={item.title}
                className="group overflow-hidden rounded-3xl border border-slate-200/80 bg-white shadow-lg shadow-slate-200/40 transition duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#6756FE]/10"
              >
                <div className="overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-44 w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <h4 className="font-bold text-slate-900">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-500">{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#0e0e11] text-white py-20 px-4 md:px-20">
      <div className="max-w-6xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-400 mb-4">
          Who Can Join This Trading Options Program?
        </h2>
        <p className="text-gray-300 max-w-3xl mx-auto">
          Option Trading is no longer exclusive to a select few. Our program is designed to help individuals from various professions and age groups discover their potential in the world of multi-asset trading. We firmly believe that anyone can learn and succeed in trading, regardless of their background or experience.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-center">
        {joinCards.map((item, index) => (
          <div key={index} className="bg-[#1a1a1a] p-4 rounded-2xl shadow hover:shadow-lg transition">
            <img
              src={item?.image}
              alt={item?.title}
              className="rounded-xl w-full h-[180px] object-cover mb-4"
            />
            <h4 className="text-white font-semibold mb-2">{item?.title}</h4>
            <p className="text-gray-400 text-sm">{item?.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhoCanJoin;
